module.exports = __webpack_public_path__ + "img/1588676668.b66fc8ef.jpg";